/* esm.sh - react-dom@18.3.1/client */
export * from "/*react-dom@18.3.1/esnext/client.mjs";
export { default } from "/*react-dom@18.3.1/esnext/client.mjs";
